// extracted by mini-css-extract-plugin
export var text = "_bw-0";